import BaseClass from "../BaseClass";

export class DocumentFileInput extends BaseClass {
    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        this.jqXHR = null;

        this.initElements();
        this.initListeners();

        const initialState = this.$element.data('initial-state');
        const initialFilename = this.$element.data('initial-filename');

        if (initialState !== undefined) {
            switch (initialState) {
                case 'selected':
                    this.setStateSelected(initialFilename ?? '');
                    break;
                case 'uploaded':
                    this.setStateUploaded();
                    break;
            }
        }
    }

    initElements() {
        this.$input = this.$element.find(':file');
        this.$label = this.$input.map(function () {
            return Array.from(this.labels.values());
        });
        this.$form = this.$input.map(function () {
            return this.form;
        });
        this.$fileName = this.$element.find('.file__file-name');
        this.$submitButton = this.$element.find('.btn--submit');
        this.$deleteButton = this.$element.find('.file__delete');
    }

    initListeners() {
        this.$input.on('input', $.proxy(this.onFileInput, this));
        this.$input.on('click', $.proxy(this.onFileClick, this));
        this.$submitButton.on('click', $.proxy(this.onSubmitButtonClick, this));
        this.$deleteButton.on('click', $.proxy(this.onDeleteClick, this));
    }

    onFileInput(event, data) {
        const filename = event.target.files[0].name;

        this.setStateSelected(filename);
    }

    onFileClick(event, data) {
        this.$element.trigger('document_file_input:file:click');

        event.stopPropagation();
    }

    onSubmitButtonClick() {
        if (this.jqXHR !== null) {
            this.jqXHR.abort();
            this.jqXHR = null;
        }

        const url = this.$element.data('url');
        const formData = new FormData();
        this.$input.each(function () {
            for (const file of this.files) {
                formData.append(this.name, file);
            }
        });

        this.jqXHR = $.ajax({
            url,
            type: 'POST',
            data: formData,
            success: $.proxy(this.onUploadDone, this),
            error: $.proxy(this.onUploadError, this),
            processData: false,
            contentType: false
        });
    }

    onUploadDone(data) {
        this.setStateUploaded();

        this.$element.trigger('document_file_input:done');
    }

    onUploadError(data) {
        if (data.responseJSON != undefined) {
            this.$element.trigger('form:error:add', {errors: data.responseJSON.errors});
        }
    }

    onDeleteClick(event, data) {
        this.setStateInitial();
    }

    setStateInitial() {
        this.$fileName.empty();
        this.$label.removeClass('file--selected file--uploaded').addClass('file--initial');
        this.$input.val('');
    }

    setStateUploaded() {
        this.$label.removeClass('file--initial file--selected').addClass('file--uploaded');
    }

    setStateSelected(filename) {
        this.$fileName.text(filename);
        this.$label.removeClass('file--initial file--uploaded').addClass('file--selected');
    }

    destroyListener() {
        if (this.jqXHR !== null) {
            this.jqXHR.abort();
            this.jqXHR = null;
        }

        this.teardownListeners();
        this.teardownElements();
    }

    teardownListeners() {
        this.$deleteButton.off('click', $.proxy(this.onDeleteClick, this));
        this.$submitButton.off('click', $.proxy(this.onSubmitButtonClick, this));
        this.$input.off('click', $.proxy(this.onFileClick, this));
        this.$input.off('input', $.proxy(this.onFileInput, this));
    }

    teardownElements() {
        delete this.$deleteButton;
        delete this.$fileName;
        delete this.$form;
        delete this.$input;
    }
}